import htmlToDraft from 'html-to-draftjs';
import { ContentState, EditorState } from 'draft-js';
import _ from 'lodash';
import { handleDeleteEmbedBug } from '../../../../utils/newBedStatusUtil';
import {
  buildAEDBedList,
  normalizeLayoutNumber,
  normalizeNumber,
  parseCubiclePosition,
} from '../../../../utils/admissionUtil';

export const buildLocationSettingCubicleParams = (cubicle) => {
  const notEmptyBed = _.filter(cubicle.data.beds, (item) => item?.bedName !== '');

  return {
    beds: _.map(notEmptyBed, (bedItem) => ({
      bedName: bedItem.bedName,
      cubColumn: bedItem.column,
      cubRow: bedItem.row,
    })),
    borderLine: cubicle.data.borderLine,
    cubColour: cubicle.data.color,
    cubColumns: String(cubicle.data.bedArrangement.column),
    cubRows: String(cubicle.data.bedArrangement.row),
    cubType: cubicle.data.type,
    cubicleId: cubicle.id > 0 ? cubicle.id : null,
    gender: cubicle.data.gender,
    header: cubicle.data.header ?? 'show',
    height: String(cubicle.height),
    name: cubicle.data.name,
    remark: cubicle.data.type === 'Memo' ? handleDeleteEmbedBug(cubicle.data.remarks) : cubicle.data.remarks,
    rmkColour: cubicle.data.remarkColor,
    status: cubicle.data.status,
    width: String(cubicle.width),
    position: JSON.stringify({
      X: cubicle.x,
      Y: cubicle.y,
    }),
  };
};

export const revampLocationSettingCubicle = (cubicle) => {
  const position = parseCubiclePosition(cubicle?.position);
  let remarks = cubicle.remark;
  if (cubicle.cubType === 'Memo') {
    const blocksFromHtml = htmlToDraft(cubicle?.remark ?? '');
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    remarks = EditorState.createWithContent(contentState);
  }

  return {
    width: normalizeLayoutNumber(cubicle?.width),
    height: normalizeLayoutNumber(cubicle?.height),
    x: normalizeLayoutNumber(position?.X ?? position?.x),
    y: normalizeLayoutNumber(position?.Y ?? position?.y),
    id: normalizeNumber(cubicle?.cubicleId),
    data: {
      name: cubicle?.name,
      type: cubicle?.cubType ?? '',
      status: cubicle?.status ?? '',
      gender: cubicle?.gender ?? '',
      color: cubicle?.cubColour,
      remarks,
      remarkColor: cubicle?.rmkColour,
      bedArrangement: { column: cubicle?.cubColumns, row: cubicle?.cubRows },
      borderLine: cubicle?.borderLine,
      header: cubicle?.header,
      beds: buildAEDBedList({
        beds: cubicle?.beds,
        cubicleRows: cubicle?.cubRows,
        cubicleCols: cubicle?.cubColumns,
        editMode: true,
      }),
    },
  };
};
